import { render, staticRenderFns } from "./ReportNewness.vue?vue&type=template&id=404c05ba&"
import script from "./ReportNewness.vue?vue&type=script&lang=js&"
export * from "./ReportNewness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports